import { Link } from "react-router-dom";
import { ArrowRight, PackageCheck, ShieldCheck, Truck } from "lucide-react";
import { Header, Footer } from "@/components/Chrome";

const About = () => (
  <div className="site-shell">
    <Header />
    <main data-testid="about-page">
      <section className="legal-hero">
        <p className="eyebrow" data-testid="about-kicker">ABOUT DECODEAUTODEALS</p>
        <h1 data-testid="about-title">The part you need.<br /><em>The standard you deserve.</em></h1>
        <p className="legal-intro" data-testid="about-intro">DECODEAUTODEALS is an independent used auto-parts company serving drivers, repair shops, and fleets in all 50 states — with quality-checked parts, our own shipping network, and a parts desk that treats every request personally.</p>
      </section>

      <section className="about-story section-pad" data-testid="about-story">
        <div className="about-photo" data-testid="about-photo" />
        <div>
          <div className="section-kicker">OUR STORY</div>
          <h2>Built around one<br /><em>simple promise.</em></h2>
          <p className="about-copy">Buying a used part should not feel like a gamble. We started DECODEAUTODEALS to bring a higher standard to the second-hand parts market — the right part, verified for your vehicle, described honestly, and delivered to your door anywhere in the USA.</p>
          <p className="about-copy">Instead of listing thousands of parts and leaving you to guess, we work the other way around: you tell us what your vehicle needs, and our specialists match it against stock across our fulfillment hubs. You receive one clear quote — part, condition, mileage, and shipping included.</p>
        </div>
      </section>

      <section className="stat-band" data-testid="about-stats">
        <div data-testid="about-stat-states"><strong>50</strong><span>States served</span></div>
        <div data-testid="about-stat-hubs"><strong>4</strong><span>Fulfillment hubs · Omaha, Dallas, Atlanta, Reno</span></div>
        <div data-testid="about-stat-desk"><strong>1</strong><span>Dedicated parts desk</span></div>
      </section>

      <section className="process section-pad" data-testid="about-values">
        <div className="section-kicker">HOW WE WORK</div>
        <h2>What we hold<br /><em>ourselves to.</em></h2>
        <div className="steps">
          <div data-testid="about-value-quality"><span>01</span><ShieldCheck /><h3>Quality, checked twice</h3><p>Every engine, transmission, and component is inspected and graded before it is offered to you.</p></div>
          <div data-testid="about-value-honesty"><span>02</span><PackageCheck /><h3>Honest descriptions</h3><p>Mileage, condition, and history are confirmed in writing before you pay — no surprises at the door.</p></div>
          <div data-testid="about-value-delivery"><span>03</span><Truck /><h3>Delivered by us</h3><p>Our own shipping network moves your part from the nearest hub, with care taken at every mile.</p></div>
        </div>
      </section>

      <section className="closing-cta" data-testid="about-cta">
        <div><div className="section-kicker">READY WHEN YOU ARE</div><h2>Let’s find<br /><em>your part.</em></h2></div>
        <Link className="gold-button" to="/?quote=1" data-testid="about-quote-link">Request a quote <ArrowRight size={17} /></Link>
      </section>
    </main>
    <Footer />
  </div>
);

export default About;
